import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Link } from 'react-router';
import { Theme } from '../../config/theme.js';

export default class Paragraph extends Component {
  render() {
    if(this.props.htmlContent) {
      return (
        <div className={css(styles.paragraph, this.props.style)} dangerouslySetInnerHTML={{
              '__html': this.props.htmlContent
            }} />
        );
    } else {
      return (
        <div className={css(styles.paragraph, this.props.style)}>{this.props.children}</div>
      );
    }
  }
}

const styles = StyleSheet.create({
  paragraph: {
    display: 'block',
    flex: 1,
    fontFamily: Theme.fontFamily,
    fontSize: 14,
    lineHeight: '24px',
    color: Theme.black,
    fontWeight: 300,
    letterSpacing: 1,
    marginBottom: 20,
  }
})



// WEBPACK FOOTER //
// ./src/components/Paragraph/index.js